import { render, staticRenderFns } from "./SendTicketDateForm.vue?vue&type=template&id=fb80a3b0&scoped=true"
import script from "./SendTicketDateForm.vue?vue&type=script&lang=ts"
export * from "./SendTicketDateForm.vue?vue&type=script&lang=ts"
import style0 from "./SendTicketDateForm.vue?vue&type=style&index=0&id=fb80a3b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb80a3b0",
  null
  
)

export default component.exports